export default "__VITE_ASSET__9dc7ecdd__"